import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useToggleableSectionStyles = createUseStyles({
  toggleableHeader: {
    color: colors.gray350,
    userSelect: 'none',
    cursor: 'pointer',

    '& > i': {
      marginRight: '0.5rem'
    },
    '& > h2': {
      fontSize: '20px',
      margin: '1rem 0'
    }
  },
  toggleableContent: {
    display: 'none',
    padding: '1rem 0',

    '&.active': {
      display: 'block'
    }
  }
})

export { useToggleableSectionStyles }
